import React from 'react';
import { connect } from 'react-redux';
import fields, { globalFieldLengths } from '@/constants/fields';
import VocabularyLinkInput from '../components/VocabularyLinkInput';
import VocabularyLinkValueContainer, {
  mapDispatchToProps,
  mapStateToProps,
} from '../components/VocabularyLinkValueContainer';

const VocabularyLinkUrl = ({
  href,
  linkUUID,
  exists,
  canRead,
  updateProperties,
  updateErrors,
}) => {
  const updateLinkUrl = (value) => (
    updateProperties(linkUUID, { href: value })
  );

  const error = updateErrors.find((e) => (
    e.context.linkUUID === linkUUID && e.fields.includes(fields.URL)));

  return (
    <VocabularyLinkValueContainer exists={exists} canRead={canRead}>
      <VocabularyLinkInput
        error={error}
        fluid
        type="url"
        text={href}
        onChange={updateLinkUrl}
        maxLength={globalFieldLengths.url}
      />
    </VocabularyLinkValueContainer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(VocabularyLinkUrl);
